import { HeroImage } from 'components/HeroImage';
import { FC } from 'react';
import { Logo } from 'components/Logo';
import { useIsMobileDevice } from 'utils/browserUtil';
import { Link } from '@1debit/chimekit';

type Props = {
	testId: string;
	title?: string;
	message?: string;
};

const DEFAULT_TITLE = 'We hit a snag';
const DEFAULT_MESSAGE =
	"Please make sure you have copied the URL correctly. If you're still having trouble please get in touch with our support team for further assistance.";

export const ImproperLink: FC<Props> = ({ title = DEFAULT_TITLE, message = DEFAULT_MESSAGE, testId }) => {
	const isMobileDevice = useIsMobileDevice();

	return (
		<div data-testid={testId} className="flex flex-col p-6 sm:p-12">
			<Logo />
			<HeroImage src="/assets/images/desert.svg" />
			<h1 className="text-xl font-bold mb-3">{title}</h1>
			<p className="mb-10">{message}</p>
			{isMobileDevice ? (
				<Link analyticsId={null} variant="primary" href="tel:8442446363">
					Call us
				</Link>
			) : (
				<div className="flex gap-2">
					<p className="font-bold mt-auto">Call us at (844) 244-6363</p>
				</div>
			)}
		</div>
	);
};
